module.exports = __webpack_public_path__ + "img/12.d48d1c57.jpg";